function downloadReview(elementId) {
    const element = document.getElementById(elementId).innerHTML;
    const options = {
        margin: 15,
        filename: 'Demand Information.pdf',
        image: { type: 'jpeg', quality: 1.0 },
        html2canvas: { scale: 4 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
    };
    html2pdf(element, options);
}